"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _colors = require("HubStyleTokens/colors");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 330px;\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 100%;\n  max-width: 140px;\n  color: ", ";\n  text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var EmptyShoppingCartText = (0, _styledComponents.default)(_Small.default).withConfig({
  displayName: "EmptyShoppingCart__EmptyShoppingCartText",
  componentId: "nnohtt-0"
})(_templateObject(), _colors.EERIE);
var EmptyShoppingCartContainer = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "EmptyShoppingCart__EmptyShoppingCartContainer",
  componentId: "nnohtt-1"
})(_templateObject2(), _colors.BATTLESHIP);

function EmptyShoppingCart() {
  return _react.default.createElement(EmptyShoppingCartContainer, {
    direction: "column",
    align: "center",
    justify: "center"
  }, _react.default.createElement(_UIIllustration.default, {
    name: "store-disabled",
    width: "125px",
    className: "m-bottom-4"
  }), _react.default.createElement(EmptyShoppingCartText, null, _react.default.createElement(_FormattedMessage.default, {
    message: "bundles.shoppingCart.emptyCart"
  })));
}

var _default = EmptyShoppingCart;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/shopping-cart/EmptyShoppingCart.js
// module id = 708
// module chunks = 5 6